<template>
    <div>
        <el-row :gutter="20" style="margin-bottom: 20px">
            <el-col :span="6">
                &nbsp;
                <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true" v-if="$isFullAdmin">{{$t('common.create')}}</el-button>
                <el-button icon="el-icon-download" @click="download" v-if="$isAdmin">{{$t('common.export')}}</el-button>
            </el-col>
            <el-col :span="4" style="text-align: right;">
                <el-radio-group v-model="filter.isActive">
                    <el-radio-button label="">{{$t('common.all')}}</el-radio-button>
                    <el-radio-button label="false">{{$t('common.pending')}}</el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="4">
                <country-selector v-model="filter.countryId"></country-selector>
            </el-col>
            <el-col :span="6">
                <el-input v-model="filter.text" prefix-icon="el-icon-search" :placeholder="$t('masters.searchByNameOrCode')"></el-input>
            </el-col>
            <el-col :span="4">
                <el-input v-model="filter.state" prefix-icon="el-icon-search" :placeholder="$t('common.state')"></el-input>
            </el-col>
        </el-row>
        <el-table size="mini" :data="serviceCompanies" v-loading="loading" class="orders-table tablewithshading">
            <el-table-column prop="code" :label="$t('common.code')"></el-table-column>
            <el-table-column prop="name" :label="$t('common.name')"></el-table-column>
            <el-table-column prop="country" :label="$t('common.country')"></el-table-column>
            <el-table-column :label="$t('common.phone')">
                <template slot-scope="scope">
                    <a :href="'callto:'+scope.row.phone">{{scope.row.phone}}</a>
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.email')">
                <template slot-scope="scope">
                    <a :href="'mailto:'+scope.row.email">{{scope.row.email}}</a>
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.operations')" fixed="right" :width="$isSuperAdmin ? 230 : 98 + 'px'">
                <template slot-scope="scope">
                    <el-button size="mini" @click="editServiceCompany(scope.row.id)">
                        <i class="el-icon-edit"></i>
                    </el-button>
                    <el-tooltip class="item" effect="dark" :content="$t('masters.suspendServiceCompany')" placement="top" v-if="scope.row.isActive && $isFullAdmin && $isSuperAdmin">
                        <el-button size="mini" @click="changeCompanyStatus(scope.row, false)">
                            <i class="el-icon-close"></i>
                        </el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="$t('masters.activateServiceCompany')" placement="top" v-if="!scope.row.isActive && $isFullAdmin">
                        <el-button size="mini" @click="changeCompanyStatus(scope.row, true)">
                            <i class="el-icon-check"></i>
                        </el-button>
                    </el-tooltip>
                    <el-button size="mini" type="danger" @click="deleteServiceCompany(scope.row.id)" v-if="$isSuperAdmin">
                        <i class="el-icon-delete"></i>
                    </el-button>
                    <el-tooltip class="item" effect="dark" :content="$t('masters.impersonate')" placement="top" v-if="$isFullAdmin && $isSuperAdmin">
                        <el-button size="mini" @click="impersonateServiceCompany(scope.row.id)" v-if="$isFullAdmin">I</el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" v-if="total !== 0"
                       @current-change="handleCurrentChange"
                       :current-page.sync="currentPage"
                       :page-size="15"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
        <create-update-service-company-dialog :serviceCompanyId="serviceCompanyToEdit" :visible="dialogVisible" @dialogClosed="editFinished" @save="appendServiceCompany"></create-update-service-company-dialog>
    </div>
</template>

<script>
    import CreateUpdateServiceCompanyDialog from './CreateUpdateServiceCompanyDialog'
    import { CountrySelector } from '@/app/shared/components'
    import api from '../api'
    import axios from 'axios'

    export default {
        name: 'service-company-list',
        components: {
            CreateUpdateServiceCompanyDialog,
            CountrySelector
        },
        data() {
            return {
                serviceCompanies: [],
                loading: true,
                dialogVisible: false,
                serviceCompanyToEdit: null,
                filter: {
                    countryId: undefined,
                    isActive: '',
                    text: undefined,
                    state: undefined
                },
                currentPage: 1,
                total: 0
            }
        },
        created() {
            this.loadServiceCompanies();
        },
        watch: {
            filter: {
                deep: true,
                handler: function (val) {
                    this.loadServiceCompanies();
                }
            }
        },
        methods: {
            download() {
                api.download(this.filter);
            },
            loadServiceCompanies() {
                this.loading = true
                api.getServiceCompanies(this.currentPage, this.filter.isActive, this.filter.countryId, this.filter.text, this.filter.state).then(response => {
                    this.loading = false
                    this.serviceCompanies = response.data.items
                    this.total = response.data.total
                })
            },
            appendServiceCompany(event) {
                if (event.new) {
                    this.serviceCompanies.push(event.data);
                    this.total += 1;
                } else {
                    this.loadServiceCompanies();
                }
            },
            handleCurrentChange(page) {
                this.currentPage = page;
                this.loadServiceCompanies();
            },
            editServiceCompany(id) {
                this.serviceCompanyToEdit = id
                this.dialogVisible = true
            },
            editFinished() {
                this.serviceCompanyToEdit = null
                this.dialogVisible = false
            },
            deleteServiceCompany(id) {
                this.loading = true;
                this.$confirm(this.$t('common.thisWillDeleteServiceCompanyContinue'), 'Warning', {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: 'warning'
                }).then(() => {
                    // get servicecompany information
                    api.getServiceCompany(id).then(servicecompany => {
                        api.deleteUser(servicecompany.code).then(response => {
                            api.deleteServiceCompany(id).then(() => {
                                this.loadServiceCompanies();
                                this.$message({
                                    type: 'success',
                                    message: this.$t('common.deleteCompleted')
                                })
                                this.loading = false;
                            }).catch(err => {
                                this.loading = false;
                                this.$message({
                                    type: 'error',
                                    message: this.$t('common.errorWhileDeleteTheServiceCompany')
                                })
                            });
                        }).catch(err => {
                            this.loading = false;
                            this.$message({
                                type: 'error',
                                message: this.$t('common.errorWhileDeleteTheServiceCompany')
                            })
                        });
                    });
                    
                })
                .catch(_ => {
                    this.loading = false;
                });;
            },
            changeCompanyStatus(company, activate) {
                this.$confirm(`This will ${activate ? 'activate' : 'deactivate'} service company. Continue?`, 'Warning', {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: 'info'
                }).then(() => {
                    api.changeActivationStatus(company.id, activate).then(response => {
                        company.isActive = activate;
                        this.$message({
                            type: 'success',
                            message: `Company ${activate ? 'activated' : 'deactivated'}`
                        })
                    });
                }).catch(_ => {});
            },
            impersonateServiceCompany(id) {
                api.impersonate(id).then(response => {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                    localStorage.setItem("isImpersonateUser", "true");
                    window.signInManager.signinRedirect();
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ClientApp/app/masters/servicecompanies/components/ServiceCompanyList.vue